import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateDefaultParser } from '@ngx-translate/core';
import { APP_CONFIG } from '../environment';

/**
 * Will display the message below when referencing a key not found in the language culture file. 
 * Seems like this does not work when using the pipe.
 */
export class TranslationFallbackHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return `${params.key} NOT FOUND`;
  }
}
export class TranslationParserHandler extends TranslateDefaultParser {
  getValue(target: any, key: string): any {
    let country = APP_CONFIG.region.defaultCountryFrom;
    let brandingLocale = APP_CONFIG.branding.locale;
    let value = null;
    if (key.endsWith('__'))
      key = key.replace('__', '');
    else
      value = super.getValue(target, key + '_' + brandingLocale);
    if (!value)
      value = super.getValue(target, key + '_' + country);
    if (!value)
      value = super.getValue(target, key);
    return value;
  }

  interpolate(expr: string | Function, params?: any) {
    params = {
      ...APP_CONFIG.region.defaultTranslationParams,
      currency: APP_CONFIG.region.defaultCurrencyFrom,
      ...params,
    };
    return super.interpolate(expr, params)
  }
}


// WEBPACK FOOTER //
// ./src/translations/translation-fallback.provider.ts